import { Rpc, RpcGroup } from "effect/rpc";
import { Schema } from "effect";
import { AppointmentPrintLocationResult } from "./appointment-printing.schema";

/**
 * Read-only RPC for location metadata of an already-confirmed appointment.
 *
 * @since 1.2.0
 * @example
 * ```ts
 * const group = FrontDeskAppointmentPrintingRpcs;
 * ```
 */
export class FrontDeskAppointmentPrintingRpcs extends RpcGroup.make(
  Rpc.make("FrontDeskGetAppointmentPrintLocation", {
    success: AppointmentPrintLocationResult,
    payload: Schema.Struct({
      scheduleId: Schema.String.pipe(Schema.check(Schema.isMinLength(1)), Schema.check(Schema.isMaxLength(120))),
      expectedPatientId: Schema.String.pipe(Schema.check(Schema.isMinLength(1)), Schema.check(Schema.isMaxLength(120))),
    }),
  }),
) {}
